export type CommunicationTypesProps = {
  hasBuildingWideWireless: boolean;
  hasCableTv: boolean;
  hasHighSpeedInternet: boolean;
  hasSatelliteTv: boolean;
};

const CommunicationTypes = ({
  hasBuildingWideWireless = false,
  hasCableTv = false,
  hasHighSpeedInternet = false,
  hasSatelliteTv = false,
}: Partial<CommunicationTypesProps> = {}): CommunicationTypesProps => ({
  hasBuildingWideWireless: Boolean(hasBuildingWideWireless),
  hasCableTv: Boolean(hasCableTv),
  hasHighSpeedInternet: Boolean(hasHighSpeedInternet),
  hasSatelliteTv: Boolean(hasSatelliteTv),
});

export default CommunicationTypes;
